import { useEffect, useState } from 'react';
import L from 'leaflet';
import { LAYERS } from '../lib/mapUrls';
import { listMaps, ownLayer } from '../lib/ownTiles';
import { usePolicy, extOk, companyMap, cacheOk } from '../lib/policy';

// base map choices: public tiles (unless KRITIS forbids), company map server, imported MBTiles, saved offline areas, white
export function useBaseMaps(t) {
  const { kritis } = usePolicy();
  const [maps, setMaps] = useState([]);
  useEffect(() => { const on = () => listMaps().then(setMaps, () => {}); on(); window.addEventListener('giss-ownmaps', on); return () => window.removeEventListener('giss-ownmaps', on); }, []);
  const pub = extOk('tiles'), own = companyMap();
  const list = [
    ...(pub ? Object.keys(LAYERS).map((k) => [k, t['layer_' + k]]) : []),
    ...(own ? [['own', own.name || t.omCompany]] : []),
    ...maps.map((m) => [m.id, `🗺️ ${m.name}`]),
    ...(kritis && !pub && cacheOk() ? [['cache', t.omCache]] : []),
    ['blank', t.omBlank],
  ];
  return { list, maps, kritis };
}

export function makeBase(key, maps) {
  if (LAYERS[key]) { const [url, maxZoom] = LAYERS[key]; return L.tileLayer(url, { maxZoom: 24, maxNativeZoom: Math.min(maxZoom, 20), crossOrigin: 'anonymous' }); }
  if (key === 'own') {
    const m = companyMap();
    if (!m) return null;
    return m.type === 'wms' ? L.tileLayer.wms(m.url, { layers: m.layers, format: 'image/png', version: '1.3.0', maxZoom: 24 }) : L.tileLayer(m.url, { maxZoom: 24, maxNativeZoom: 20 });
  }
  return key === 'blank' ? null : ownLayer(key, maps.find((m) => m.id === key));
}
